import { ButtonIcon } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { styled } from 'styled-components';
import { selectedMetadataAtom } from '../../atoms/selectedMetadata';
import themeHelper from '../../utils/themeHelper';
import MetadataSelection from '../MetadataSelection';

const FullVideoSearchContainer = styled.div`
  display: flex;
  gap: ${themeHelper.spacing()};
  justify-content: space-between;
`;
const FullVideoSearchElementContainer = styled.span`
  flex-grow: 1;
`;
const ButtonContainer = styled.span`
  align-self: flex-end;
  display: flex;
  flex-direction: column;
  padding: ${themeHelper.spacing(1, 0)};
`;

export function FullVideoSearchBox({ onSearch }) {
  const intl = useIntl();

  const selectedMetadata = useAtomValue(selectedMetadataAtom);

  const onFullVideoSearchSubmit = () => {
    onSearch({
      matchId: selectedMetadata.matchId,
      period: selectedMetadata.period,
      sport: selectedMetadata.sport,
      track: selectedMetadata.track,
      version: selectedMetadata.version,
    });
  };

  return (
    <FullVideoSearchContainer>
      <FullVideoSearchElementContainer>
        <MetadataSelection />
      </FullVideoSearchElementContainer>
      <ButtonContainer>
        <ButtonIcon
          icon="Search"
          onClick={onFullVideoSearchSubmit}
          title={intl.formatMessage({
            defaultMessage: 'Search',
            id: '13348',
          })}
        />
      </ButtonContainer>
    </FullVideoSearchContainer>
  );
}

FullVideoSearchBox.propTypes = { onSearch: PropTypes.func.isRequired };

export default { FullVideoSearchBox };
